import React, { useRef, useCallback, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import _ from 'lodash'
import AvatarEditor from 'react-avatar-editor'
import './profile.css'
import axios from 'axios'
import DOMPurify from 'dompurify'

const MyProfilePhoto = ({ flashMessage }) => {
  const editor = useRef(null)
  const params = useParams()
  const history = useHistory()
  const user = window.currentUser
  let wizard = params.wizard ? 'wizard' : ''
  const { token } = params
  const [originalState, setOriginalState] = useState({
    user,
    image: null,
    allowZoomOut: false,
    position: { x: 0.5, y: 0.5 },
    scale: 1,
    rotate: 0,
    borderRadius: 0,
    width: 300,
    height: 300,
    preview: null
  })

  // sanitized for Snyk XSS protection
  const cleanOriginalPhoto = DOMPurify.sanitize(originalState.user.photo)

  const handleNewImage = useCallback((e) => {
    if(e.target.files[0]) {
      var fileType = e.target.files[0]['type']
      var ValidImageTypes = ['image/jpeg', 'image/png']
      if (_.indexOf(ValidImageTypes, fileType) < 0) {
        flashMessage({
          message: 'Profile image must be in .jpg, .jpeg, or .png format',
          level: 'error'
        })
        return false
      }
    }
    setOriginalState({ ...originalState, image: e.target.files[0]})
  },[originalState])

  const handleCrop = useCallback(() => {
    const img = editor.current.getImageScaledToCanvas().toDataURL()
    const rect = editor.current.getCroppingRect()

    setOriginalState({
      ...originalState,
      preview: {
        img,
        rect,
        scale: originalState.scale,
        width: originalState.width,
        height: originalState.height,
        borderRadius: originalState.borderRadius,
      }
    })
  },[originalState, editor])

  const handleScale = useCallback((e) => {
    const scale = parseFloat(e.target.value)
    setOriginalState({...originalState, scale})
  },[originalState])

  const rotateLeft = useCallback((e) => {
    e.preventDefault()
    setOriginalState({...originalState, rotate: originalState.rotate - 90,})
  },[originalState])

  const handlePositionChange = useCallback((position) => setOriginalState({...originalState, position }),[originalState])

  const saveBlob = useCallback(() => {
    let canvas = editor.current.getImageScaledToCanvas()
    return new Promise((resolve) => {
      return canvas.toBlob(file => {
        file.name = 'x.jpeg'
        file.lastModifiedDate = new Date()
        resolve(file)
      }, 'image/jpeg')
    })
  }, [editor])

  const saveImage = useCallback((e) => {
    handleCrop()
    e.currentTarget.disabled = true
    saveBlob().then(blob =>
    {
      const form = document.createElement('form')
      const fd = new FormData(form)
      fd.append('file', blob)
      axios.post(process.env.REACT_APP_API_URL + '/virtual_portal/upload', fd, {
        headers: {
          'Content-Type': 'multipart/form-data;',
          'Sessionauthorization': token
        }}).then((response) => {
        window.currentUser.photo = response.data.url
        let user = originalState.user
        user.photo = response.data.url
        history.push('/' + token + '/profile/' + wizard)
      }).catch((error) => {
        console.log('error', error)
      })
    })
  },[handleCrop, originalState, saveBlob, token, wizard])

  return(
    <div className="my-profile-photo">
      {!originalState.preview && !originalState.image && (
        <div>
          <p><img className="rounded-circle" alt="user" src={cleanOriginalPhoto} /></p>
          <div>
            <Link to={'/' + token + '/profile/' + wizard} className="button-link"><button className="btn btn-danger">CANCEL</button></Link>
            <label className="custom-file-upload btn-danger">
              <input name="newImage" type="file" onChange={handleNewImage} />
              UPLOAD PHOTO
            </label>
            <p>jpeg or png files only</p>
          </div>
        </div>
      )
      }
      {originalState.image &&
        <div>
          <br />
          <br />
          <AvatarEditor
            ref={editor}
            scale={parseFloat(originalState.scale)}
            width={originalState.width}
            height={originalState.height}
            position={originalState.position}
            onPositionChange={handlePositionChange}
            rotate={parseFloat(originalState.rotate)}
            borderRadius={originalState.width / (100 / originalState.borderRadius)}
            image={originalState.image}
            className="editor-canvas"
          />

          <p>Zoom:</p>
          <p>
            <input
              name="scale"
              type="range"
              onChange={handleScale}
              min={originalState.allowZoomOut ? '0.1' : '1'}
              max="2"
              step="0.01"
              defaultValue="1"
            /></p>

          <p>
            <Link to={'/' + token + '/profile/' + wizard}><button className="btn btn-danger" >Cancel</button></Link>
            <button
              className="btn btn-primary"
              onClick={(e) => rotateLeft(e)}>
              Rotate
              &nbsp;&nbsp;
              <i className="fa fa-repeat"></i>
            </button>
            <button className="btn btn-primary" onClick={(e) => saveImage(e)}>Save</button>
          </p>
        </div>
      }
    </div>
  )



}

export default MyProfilePhoto